var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampanhas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.335 2.58579C16.9616 2.21071 16.4553 2 15.9273 2H14.9318V0H12.9409V2H4.97727V0H2.98636V2H1.99091C1.46289 2 0.956492 2.21071 0.583127 2.58579C0.209752 2.96086 0 3.46957 0 4V18C0 19.1 0.885954 20 1.99091 20H15.9273C16.4553 20 16.9616 19.7893 17.335 19.4142C17.7084 19.0391 17.9182 18.5304 17.9182 18V4C17.9182 3.46957 17.7084 2.96086 17.335 2.58579ZM5.97273 11V9H3.98182V11H5.97273ZM9.95455 11V9H7.96364V11H9.95455ZM13.9364 9V11H11.9455V9H13.9364ZM15.9273 18V7H1.99091V18H15.9273ZM5.97273 15V13H3.98182V15H5.97273ZM9.95455 13V15H7.96364V13H9.95455ZM13.9364 15V13H11.9455V15H13.9364Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.335 2.58579C16.9616 2.21071 16.4553 2 15.9273 2H14.9318V0H12.9409V2H4.97727V0H2.98636V2H1.99091C1.46289 2 0.956492 2.21071 0.583127 2.58579C0.209752 2.96086 0 3.46957 0 4V18C0 19.1 0.885954 20 1.99091 20H15.9273C16.4553 20 16.9616 19.7893 17.335 19.4142C17.7084 19.0391 17.9182 18.5304 17.9182 18V4C17.9182 3.46957 17.7084 2.96086 17.335 2.58579ZM5.97273 11V9H3.98182V11H5.97273ZM9.95455 11V9H7.96364V11H9.95455ZM13.9364 9V11H11.9455V9H13.9364ZM15.9273 18V7H1.99091V18H15.9273ZM5.97273 15V13H3.98182V15H5.97273ZM9.95455 13V15H7.96364V13H9.95455ZM13.9364 15V13H11.9455V15H13.9364Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampanhas);
export default __webpack_public_path__ + "static/media/campanhas.6b067f80dffdc9b39e98e155bfe05ca0.svg";
export { ForwardRef as ReactComponent };